import type { FormError } from '../types/form';

export const DEFAULT_ERROR: FormError = {
  errors: [],
  errorMessages: {},
  hasError: false,
  isTouched: false,
};

export const SINGLE_PATTERN_ERROR_MESSAGE = `Le format du champ %{fieldName}% est invalide`;
export const MULTIPLE_PATTERN_ERROR_MESSAGE = `Les formats des champs %{fieldName}% sont invalides`;
export const SINGLE_REQUIRED_ERROR_MESSAGE = `Le champ %{fieldName}% est requis`;
export const MULTIPLE_REQUIRED_ERROR_MESSAGE = `Les champs %{fieldName}% sont requis`;
